import { Button, Checkbox, FormControlLabel, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { useRecordContext } from "react-admin";
import { Controller, useForm } from "react-hook-form";
import CustomProductIntTextField from "../../unit/forms/CustomProductIntTextField";
import CustomProductSelect from "../../unit/forms/CustomProductSelect";
import FieldTitle from "./FieldTitle";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import CustomProductActionBottom from "../CustomProductActionBottom";

export default function Process({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const sectionName = "process";
  const sectionTitle = "Process - Set required review steps";
  const sectionSubtitle = "";

  const data = record?.data?.basic?.process;
  const subType = record?.data?.basic?.subType;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;
  const [prevalue, setPrevalue] = React.useState("NO");
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
    setValue,
    watch,
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      sPreApprove: "NO",
      sPreApproveNeedCounselorFile: "NO",
      iCounselorVerification: 0,
      ...(defaultValues || {}),
    },
  });

  // // 监视 multiple_reviews_steps 值的变化
  // const multipleReviewsSteps = watch("multiple_reviews_steps");

  React.useEffect(() => {
    if (data) {
      reset({
        sPreApprove: data?.sPreApprove || "NO",
        sPreApproveNeedCounselorFile:
          data?.sPreApprove === "YES"
            ? data?.sPreApproveNeedCounselorFile || "NO"
            : "NO",
        loanoffer_acceptance: data?.loanoffer_acceptance || "",
        multiple_reviews: data?.multiple_reviews,
        // multiple_reviews_steps: data?.multiple_reviews_steps || [],
        skipReview: data?.skipReview || "NO",
        iCounselorVerification:
          typeof data?.iCounselorVerification === "number"
            ? data?.iCounselorVerification
            : 0,
      });
      setPrevalue(data?.sPreApprove || "NO");
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    // 确保 iCounselorVerification 是 0 或 1
    formData.iCounselorVerification = formData.iCounselorVerification ? 1 : 0;
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  const ShowPreApprovalType = [
    "start",
    "employee",
    "refund",
    "builder",
    "buildingladder",
    "account",
    "depositoryaccount",
  ];

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />
      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        {/* Pre-Approval */}
        {!ShowPreApprovalType?.includes(subType) && (
          <>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <FieldTitle title="Pre Approval" />
              </Grid>
              <Grid item xs={2}>
                <Controller
                  name="sPreApprove"
                  control={control}
                  render={({ field }) => (
                    <CustomProductSelect
                      {...field}
                      small
                      value={prevalue}
                      variant="outlined"
                      optionlist={[
                        { value: "YES", label: "YES" },
                        { value: "NO", label: "NO" },
                      ]}
                      onChange={(e) => {
                        const value = e.target.value.toString();
                        setPrevalue(value);
                        setValue("sPreApprove", value, { shouldDirty: true });
                        if (value === "NO") {
                          setValue("sPreApproveNeedCounselorFile", "NO", {
                            shouldDirty: true,
                          });
                        }
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={8}>
                {prevalue === "YES" && (
                  <Controller
                    name="sPreApproveNeedCounselorFile"
                    control={control}
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={field.value === "YES"}
                            onChange={(e) => {
                              field.onChange(e.target.checked ? "YES" : "NO");
                            }}
                            size="small"
                          />
                        }
                        label="Need Document from Partner"
                        sx={{ marginTop: "2px" }}
                      />
                    )}
                  />
                )}
              </Grid>
            </Grid>

            {prevalue == "YES" && (
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <FieldTitle title="Pre-Approval Expiration" />
                </Grid>
                <Grid item xs={2}>
                  <Controller
                    name="loanoffer_acceptance"
                    control={control}
                    rules={{
                      validate: (value) => {
                        return (
                          parseFloat(value) > 0 ||
                          "Pre-Approval Expiration must be greater than 0"
                        );
                      },
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <CustomProductIntTextField
                        {...field}
                        small
                        helperText={error?.message}
                        onChange={(eValue) => {
                          const value = eValue.toString();
                          field.onChange(value === "" ? "" : parseFloat(value));
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={7}>
                  <FieldTitle title="days from Pre-Approval Offer Made" />
                </Grid>
              </Grid>
            )}
          </>
        )}

        <Grid container spacing={2}>
          <Grid item xs={2}>
            <FieldTitle title="Final Reviews" />
          </Grid>
          <Grid item xs={2}>
            <Controller
              name="multiple_reviews"
              control={control}
              render={({ field }) => (
                <CustomProductSelect
                  {...field}
                  small
                  variant="outlined"
                  optionlist={[
                    { value: 0, label: "0" },
                    { value: 1, label: "1" },
                    { value: 2, label: "2" },
                    { value: 3, label: "3" },
                    { value: 4, label: "4" },
                    { value: 5, label: "5" },
                    { value: 6, label: "6" },
                    { value: 7, label: "7" },
                    { value: 8, label: "8" },
                    { value: 9, label: "9" },
                    { value: 10, label: "10" },
                  ]}
                />
              )}
            />
          </Grid>
          <Grid item xs={8}>
            <FieldTitle title="different users" />
          </Grid>
        </Grid>

        {/* skipReview, selecte YES/NO */}
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <FieldTitle title="Skip Review" />
          </Grid>
          <Grid item xs={2}>
            <Controller
              name="skipReview"
              control={control}
              render={({ field }) => (
                <CustomProductSelect
                  {...field}
                  small
                  variant="outlined"
                  optionlist={[
                    { value: "YES", label: "YES" },
                    { value: "NO", label: "NO" },
                  ]}
                  sx={{ marginTop: "7px" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={8}></Grid>
        </Grid>

        {/* iCounselorVerification 复核人审核 Checkbox */}
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <FieldTitle title="Counselor Verification" />
          </Grid>
          <Grid item xs={6}>
            <Controller
              name="iCounselorVerification"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={field.value === 1}
                      onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                      size="small"
                    />
                  }
                  label="Require Counselor Verification"
                  sx={{ marginTop: "2px" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
      </Box>
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          disabled={!isDirty}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
